export const checkProductsWithoutSelectionByMultiple = (products: any[]) => {
    return products?.some((product) => {
        const directProducts = Object.values(product?.products || {}).filter(
            (p) => p !== null && typeof p === 'object' && !Array.isArray(p),
        );

        const generics = Array.isArray(product?.products?.generics)
            ? product.products.generics.map((g) => g?.product).filter((p) => p !== null && typeof p === 'object')
            : [];

        const allProducts = [...directProducts, ...generics];

        return product?.drugManufacturerIdSelected?.length === 0 && allProducts.some((p) => !!p?.multiple);
    });
};
